import { EventEmitter, Input, Output } from '@angular/core';
import { DropdownModel } from 'src/app/models/master/dropdown-model';
import { FormControlBase } from 'src/app/shared/inputs/form-control-base';

export abstract class DropdownFormControl extends FormControlBase<any> {

  @Input() boxStyleClass?: any = 'bg-white';
  @Input() btnStyleClass?: any = 'btn-default';
  @Input() isDisabled?: boolean;
  @Output() changed: EventEmitter<any> = new EventEmitter();
  @Output() onClick: EventEmitter<any> = new EventEmitter();
  items: Array<DropdownModel> = new Array<DropdownModel>();
  currentVal: DropdownModel;
  textSearch;
  dpItems: Array<DropdownModel> = new Array<DropdownModel>();
  filterItems: Array<DropdownModel> = new Array<DropdownModel>();
  isOpen: boolean;
  protected lastItem = 0;
  protected limitShowItem = 25;
  protected charactersEnter = 2;
  protected timeExecuteSearch = 300;
  private timeOut$;

  get isPleaseSelect() {
    return (this.value == null || this.value == '') && this.value != 0;
  }

  get isInvalid() {
    return (this.submitted || this.control.touched) && this.control.invalid && !this.isOpen;
  }

  abstract initDropdownList();

  abstract resetDropdownList(val?: any);

  findValueFromList(val: any) {
    if (val != null) {
      this.currentVal = this.items.find((item) => item.value == val);
    }
  }

  selected(val: DropdownModel) {
    this.writeValue(val ? val.value : null);
    this.currentVal = val;
    this.changed.emit(val);
  }

  trackByFnForList(index, item: DropdownModel): any {
    return item.value;
  }

  clearDropDownDefault() {
    this.items = new Array<DropdownModel>();
  }

  clkTxtSearch(e) {
    e.stopPropagation();
  }

  setAfterLoadItemDropdown() {
    this.filterItems = this.items;
    this.displayFirst();
  }

  displayFirst() {
    this.lastItem = 0;
    this.displayDropdown(true);
  }

  displayNext() {
    this.displayDropdown(false);
  }

  searchInItems(text) {
    clearTimeout(this.timeOut$);

    if (text.length === 0) {
      this.filterItems = this.items;
      this.displayFirst();
    } else if (text.length >= this.charactersEnter) {
      this.timeOut$ = setTimeout(() => {
        // filter items
        this.filterItems = this.items.filter(item => {
          return this.filterSearchItemCustom(text, item);
        });
        this.displayFirst();
      }, this.timeExecuteSearch);
    }
  }

  onOpenDropdownChange(data: boolean) {
    this.isOpen = data;
  }

  protected filterSearchItemCustom(search: string, item: DropdownModel): boolean {
    return item.label ? item.label.search(search) !== -1 : false;
  }

  onHidden() {
    this.displayFirst();
  }

  onShown() {
    const uiEl = document.getElementById('dropdown-alignment');
    if (uiEl) {
      uiEl.scrollTop = 0;
    }
  }

  protected setValue(val: any) {
    super.setValue(val);
    if (val == null) {
      this.currentVal = null;
    } else {
      this.findValueFromList(val);
    }
  }

  private displayDropdown(isFirst: boolean) {
    if (this.filterItems && this.filterItems.length > 0 && this.lastItem <= this.filterItems.length) {
      let nextItem = this.lastItem + this.limitShowItem;
      if (nextItem >= this.filterItems.length) {
        nextItem = this.filterItems.length;
      }

      if (isFirst) {
        this.dpItems = this.filterItems.slice(this.lastItem, nextItem);
      } else {
        this.dpItems.push(...this.filterItems.slice(this.lastItem, nextItem));
      }
      this.lastItem = nextItem;
    } else {
      // no data
      this.dpItems = [];
    }
  }

}
